import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, User, LogOut, ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';

const getItemLabel = (count) => (count === 1 ? 'item' : 'items');

/**
 * Mobile slide-down menu. Pure presentation — receives nav items + state from parent.
 */
const MobileMenu = ({
  navItems,
  ecosystemItems,
  ecosystemOpen,
  setEcosystemOpen,
  isActive,
  isEcosystemActive,
  customerUser,
  investorUser,
  cartCount,
  hasItems,
  onCloseMenu,
  onLogout,
}) => {
  return (
    <div className="lg:hidden mt-4 pb-4 space-y-1 animate-in slide-in-from-top duration-300">
      {navItems.slice(0, 2).map((item) => (
        <Link key={item.path} to={item.path} onClick={onCloseMenu}>
          <Button
            variant="ghost"
            className={`w-full justify-start ${
              isActive(item.path) ? 'bg-green-50 text-green-700 font-semibold' : 'text-gray-700 hover:text-green-700 hover:bg-green-50'
            } transition-all duration-300`}
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
          >
            {item.label}
          </Button>
        </Link>
      ))}

      {/* Mobile Ecosystem Expandable */}
      <div>
        <Button
          variant="ghost"
          onClick={() => setEcosystemOpen(!ecosystemOpen)}
          className={`w-full justify-between ${
            isEcosystemActive ? 'bg-green-50 text-green-700 font-semibold' : 'text-gray-700 hover:text-green-700 hover:bg-green-50'
          } transition-all duration-300`}
          data-testid="mobile-ecosystem-toggle"
        >
          Ecosystem
          <ChevronDown className={`h-4 w-4 transition-transform ${ecosystemOpen ? 'rotate-180' : ''}`} />
        </Button>
        {ecosystemOpen && (
          <div className="ml-4 mt-1 space-y-1 border-l-2 border-green-200 pl-3">
            {ecosystemItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => { onCloseMenu(); setEcosystemOpen(false); }}
              >
                <Button
                  variant="ghost"
                  className={`w-full justify-start text-sm ${
                    isActive(item.path) ? 'bg-green-50 text-green-700 font-semibold' : 'text-gray-600 hover:text-green-700 hover:bg-green-50'
                  }`}
                  data-testid={`mobile-ecosystem-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {item.label}
                </Button>
              </Link>
            ))}
            <div className="border-t border-gray-100 pt-1 mt-1">
              {customerUser || investorUser ? (
                <>
                  <Link to={investorUser ? '/investor/dashboard' : '/account'} onClick={() => { onCloseMenu(); setEcosystemOpen(false); }}>
                    <Button variant="ghost" className="w-full justify-start text-sm text-gray-600 hover:text-green-700 hover:bg-green-50" data-testid="mobile-dashboard-link">
                      <User className="h-4 w-4 mr-2" /> My Dashboard
                    </Button>
                  </Link>
                  <button onClick={() => { onLogout(); onCloseMenu(); setEcosystemOpen(false); }} className="w-full" data-testid="mobile-signout-button">
                    <Button variant="ghost" className="w-full justify-start text-sm text-red-600 hover:bg-red-50">
                      <LogOut className="h-4 w-4 mr-2" /> Sign Out
                    </Button>
                  </button>
                </>
              ) : (
                <Link to="/auth" onClick={() => { onCloseMenu(); setEcosystemOpen(false); }}>
                  <Button variant="ghost" className="w-full justify-start text-sm text-gray-600 hover:text-green-700 hover:bg-green-50" data-testid="mobile-auth-link">
                    <User className="h-4 w-4 mr-2" /> Sign In / Sign Up
                  </Button>
                </Link>
              )}
            </div>
          </div>
        )}
      </div>

      {navItems.slice(2).map((item) => (
        <Link key={item.path} to={item.path} onClick={onCloseMenu}>
          <Button
            variant="ghost"
            className={`w-full justify-start ${
              isActive(item.path) ? 'bg-green-50 text-green-700 font-semibold' : 'text-gray-700 hover:text-green-700 hover:bg-green-50'
            } transition-all duration-300`}
          data-testid={`mobile-nav-${item.label.toLowerCase()}`}
          >
            {item.label}
          </Button>
        </Link>
      ))}
      <Link to="/cart" onClick={onCloseMenu}>
        <Button
          variant="ghost"
          className={`w-full justify-start ${hasItems ? 'bg-green-50 text-green-700' : 'text-gray-700'} hover:text-green-700 hover:bg-green-50 relative`}
          data-testid="mobile-cart-link"
        >
          <ShoppingCart className="h-5 w-5 mr-2" />
          Cart {cartCount > 0 && (
            <span className="ml-2 bg-green-600 text-white text-xs rounded-full px-2 py-0.5">
              {cartCount} {getItemLabel(cartCount)}
            </span>
          )}
        </Button>
      </Link>
    </div>
  );
};

export default MobileMenu;
